import React from 'react';
import PropTypes from 'prop-types';
import debitCardHandlers from './DebitCardInfoContainer';
import DeleteButton from '../../../../common/buttons/deleteButton';

function DebitCardInfo({ card, remove, onEdit, isAdmin }) {
  return (
    <div>
      <h5>Debit Card</h5>
      <div className="c-heading c-heading--small c-heading--dark">
        Number: ************{card.details.last4}
      </div>
      <div className="c-heading c-heading--small c-heading--dark">
        Expiration: {card.details.exp_month}/{card.details.exp_year}
      </div>
      <div className="o-flexbox">
        <button
          type="button"
          onClick={onEdit}
          className="c-btn c-btn--small u-mt- u-mr-"
        >
          <span className="c-btn__text">Edit</span>
        </button>
        <DeleteButton onClick={remove} display-if={isAdmin} />
      </div>
    </div>
  );
}

DebitCardInfo.propTypes = {
  card: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

export default debitCardHandlers(DebitCardInfo);
